import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import React from "react";

import styled from "styled-components";
import {
  isSingleSleeperSelector,
  primarySleeperPrimarySleepStyleSelector,
  setPrimarySleeperPrimarySleepStyle,
  setPrimarySleeperSecondarySleepStyle,
  setSecondarySleeperPrimarySleepStyle,
  setSecondarySleeperSecondarySleepStyle,
} from "../../../../redux/slices/mattressConfiguration";
import SleepPositionButton from "./SleepPositionButton";
import sleepStyle2 from "../../../../assets/images/sleep_styles/sleep_style_2.svg";
import sleepStyleSide from "../../../../assets/images/sleep_styles/sleepStyleSide.svg";
import sleepStyleStomach from "../../../../assets/images/sleep_styles/sleepStyleStomach.svg";
import sleepStyleVaried from "../../../../assets/images/sleep_styles/sleepStyleVaried.svg";

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 65%;
`;

const StyledText = styled.div`
  font-family: noto-sans;
  font-weight: bold;
  font-size: 0.82rem;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  padding-right: 4rem;
  padding-left: 4rem;
`;

const SleepStyles = ({ editingSleeper1, primary }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const primarySleeperPrimarySleepStyle = useSelector(
    primarySleeperPrimarySleepStyleSelector
  );
  const primarySleeperSecondarySleepStyle = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.primarySleeper
        .secondarySleepStyle
  );
  const secondarySleeperPrimarySleepStyle = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.secondarySleeper
        .primarySleepStyle
  );
  const secondarySleeperSecondarySleepStyle = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.secondarySleeper
        .secondarySleepStyle
  );
  const sleepStyles = [
    { image: sleepStyleSide, title: "Side" },
    { image: sleepStyle2, title: "Back" },
    { image: sleepStyleStomach, title: "Stomach" },
    { image: sleepStyleVaried, title: "Varied" },
  ];

  const onClick = index => {
    if (isSingleSleeper || editingSleeper1) {
      if (primary) {
        return dispatch(setPrimarySleeperPrimarySleepStyle(index));
      } else {
        return dispatch(setPrimarySleeperSecondarySleepStyle(index));
      }
    } else {
      if (primary) {
        return dispatch(setSecondarySleeperPrimarySleepStyle(index));
      } else {
        return dispatch(setSecondarySleeperSecondarySleepStyle(index));
      }
    }
  };
  const unselectedSleepStyle = {
    color: theme.COLORS.BLUE.darkBlueGreen,
    width: "100%",
    padding: 0,
  };

  const selectedSleepStyle = {
    color: theme.COLORS.BLUE.darkBlueGreen,
    width: "100%",
    padding: 0,
    opacity: 0.4,
  };

  const selectedTextSleepStyle = {
    marginTop: "-6vh",
    fontSize: "0.82rem",
  };

  const clickedSleepStyle = () => {
    let selectedSleepStyle;

    if (isSingleSleeper || editingSleeper1) {
      if (primary) {
        selectedSleepStyle = primarySleeperPrimarySleepStyle;
      } else {
        selectedSleepStyle = primarySleeperSecondarySleepStyle;
      }
    } else {
      if (primary) {
        selectedSleepStyle = secondarySleeperPrimarySleepStyle;
      } else {
        selectedSleepStyle = secondarySleeperSecondarySleepStyle;
      }
    }
    return selectedSleepStyle;
  };

  return (
    <StyledContainer style={{}}>
      {sleepStyles.map((element, index) => {
        return (
          <SleepPositionButton key={index} onClick={onClick} index={index}>
            <StyledImageContainer
              style={
                clickedSleepStyle() === index
                  ? selectedSleepStyle
                  : unselectedSleepStyle
              }
            >
              <img style={{ height: "8vh" }} src={element.image}></img>
            </StyledImageContainer>
            <StyledText
              className="text-center bring-to-front"
              style={
                clickedSleepStyle() === index
                  ? selectedTextSleepStyle
                  : unselectedSleepStyle
              }
            >
              {element.title}
            </StyledText>
          </SleepPositionButton>
        );
      })}
    </StyledContainer>
  );
};

export default SleepStyles;
